import { useStore } from 'effector-react'
import * as React from 'react'

import { $error, $domain, domainMounted, getDomain } from './model'

export const useDomain = () => {
  const domain = useStore($domain)
  const loading = useStore(getDomain.pending)
  let error = useStore($error)

  React.useEffect(() => {
    domainMounted()
  }, [])

  return { domain, loading, error }
}
